import { useState } from "react";
import Button from "../common/buttons/button";
import LoginModal from "./loginModal";
import { router, usePage } from "@inertiajs/react";
import { needsCompleteRegistration } from "@/utils/registration";
import { FormattedMessage } from "react-intl";
import { Participant } from "@/types/participant";

export const getApplyLabel = (eventType) => {
    switch (eventType) {
        case "event":
            return "Register";
        case "survey":
            return "Start survey";
        default:
            return "Apply now";
    }
};

interface MobileApplyButtonInterface {
    setCompleteProfileOpen: React.Dispatch<React.SetStateAction<boolean>>;
    criteria: { label: string; eligible: boolean }[];
    slug: string;
    closed: boolean;
    participant: Participant;
    type: string;
}

export default function MobileApplyButton({
    setCompleteProfileOpen,
    criteria,
    slug,
    closed,
    participant,
    type,
}: MobileApplyButtonInterface) {
    const { auth } = usePage().props;

    const [loginModalOpen, setLoginModalOpen] = useState(false);

    return (
        <>
            <div className="sm:hidden sticky bottom-0 bg-white w-full p-4 border-t border-gray-300">
                {closed ? (
                    <span className="text-center flex justify-center">
                        <FormattedMessage id="This opportunity is now closed" />
                    </span>
                ) : participant ? (
                    <span className="text-center flex justify-center">
                        <FormattedMessage id="You've already applied for this opportunity" />
                    </span>
                ) : (
                    <Button
                        color="voice"
                        className="w-full flex justify-center items-center"
                        onClick={() => {
                            if (!auth?.user) {
                                setLoginModalOpen(true);
                            } else if (
                                needsCompleteRegistration(auth.user, criteria)
                            ) {
                                setCompleteProfileOpen(true);
                            } else {
                                router.visit(
                                    route("opportunity-application", slug),
                                );
                            }
                        }}
                    >
                        <FormattedMessage id={getApplyLabel(type)} />
                    </Button>
                )}
            </div>
            {loginModalOpen && (
                <LoginModal
                    open={loginModalOpen}
                    setOpen={setLoginModalOpen}
                    slug={slug}
                />
            )}
        </>
    );
}
